/* ET - Collection Grid — colour swatch controller.

   Clicking a swatch shows that colour without leaving the grid: it swaps the card image, price, colour label and
   every link to that colour's variant. One delegated listener per section root, so cards that arrive later (a
   theme-editor re-render, or a future filter controller replacing the grid's innerHTML) keep working.

   Lifted from the Bestseller Slider's controller (et-bestseller-slider.js) with the bs -> cg hooks; the card markup
   is a fork of that card, so the interaction has to stay identical. */

(function () {
  'use strict';

  if (window.__etCollectionGridInit) return;
  window.__etCollectionGridInit = true;

  function bindSwatches(root) {
    if (root.dataset.etCgInit === 'true') return;
    root.dataset.etCgInit = 'true';

    root.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-et-cg-swatch]');
      if (!swatch || !root.contains(swatch)) return;

      var card = swatch.closest('[data-et-cg-card]');
      if (!card) return;

      card.querySelectorAll('[data-et-cg-swatch]').forEach(function (other) {
        other.classList.remove('et-cg-card__swatch--selected');
        other.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('et-cg-card__swatch--selected');
      swatch.setAttribute('aria-pressed', 'true');

      var label = card.querySelector('[data-et-cg-color]');
      if (label) label.textContent = swatch.dataset.color;

      var image = card.querySelector('.et-cg-card__image--primary');
      if (image && swatch.dataset.image) {
        image.srcset = swatch.dataset.imageSrcset || '';
        image.src = swatch.dataset.image;
      }

      var price = card.querySelector('[data-et-cg-price]');
      if (price) {
        /* Rebuild with the same sr-only labels the server rendered, so the swap keeps its screen-reader context
           instead of leaving two bare numbers. */
        var onSale = !!swatch.dataset.compare;
        var saleLabel = onSale ? price.dataset.saleLabel : price.dataset.regularLabel;
        var html =
          '<span class="et-cg-card__price-sale"><span class="sr-only">' +
          saleLabel + '</span>' + swatch.dataset.price + '</span>';
        if (onSale) {
          html +=
            '<span class="et-cg-card__price-compare"><span class="sr-only">' +
            price.dataset.regularLabel + '</span>' + swatch.dataset.compare + '</span>';
        }
        price.innerHTML = html;
      }

      var variantUrl = swatch.dataset.variantUrl || card.dataset.productUrl;
      var available = swatch.dataset.available === 'true';

      var button = card.querySelector('[data-et-cg-button]');
      if (button) {
        button.textContent = available ? card.dataset.buttonLabel : card.dataset.soldOutLabel;
        button.classList.toggle('et-cg-card__button--disabled', !available);
        if (available) {
          button.removeAttribute('aria-disabled');
          button.setAttribute('href', variantUrl);
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('href');
        }
      }

      card.querySelectorAll('[data-et-cg-link]').forEach(function (link) {
        link.setAttribute('href', variantUrl);
      });
    });
  }

  /* The section wrapper itself carries .et-collection-grid (schema `class`), and shopify:section:load hands us that
     very element — querySelectorAll only walks descendants, so the scope must be tested too or the grid never binds
     after a theme-editor edit. */
  function boot(scope) {
    var root = scope || document;
    if (root.matches && root.matches('.et-collection-grid')) bindSwatches(root);
    root.querySelectorAll('.et-collection-grid').forEach(bindSwatches);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
